// extracted by mini-css-extract-plugin
module.exports = {"title":"Title_title__0myNW","h1":"Title_h1__i1xLc","h2":"Title_h2__Tgo55","h3":"Title_h3__B_C95"};